import { action } from 'easy-peasy';
import { setClickReportFilter } from '~/services/localStorage/filters';

import { IActionSetClickReportFilters } from '../types';

const setClickReportFilters: IActionSetClickReportFilters = action((state, payload) => {
  const updatedFilters = { ...state.click.filters, ...payload };
  // save filters to storage
  setClickReportFilter(updatedFilters);

  state.click.filters = updatedFilters;
});

export default setClickReportFilters;
